export default __webpack_public_path__ + "media/4fe57e40bf687b4656ee50d0b291d2ce78b16845b1a55692794e9915fb985435.svg";